const setIsOnlineReducer = (state, actions) => {
  return Object.assign({}, state, { online: actions.payload });
};

export default setIsOnlineReducer;
